export default __webpack_public_path__ + "static/media/06-pads-grids.c4e40ca8.jpg";